import React from 'react';
import { ArrowRight, LockKeyhole } from 'lucide-react';
import { useLocation } from 'react-router-dom';
import { useEngineSession } from '../features/session/EngineSessionProvider';

const SessionGate: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const session = useEngineSession();
  const location = useLocation();

  if (session.status === 'checking') {
    return (
      <div className="engine-app-page engine-app-loading-page" aria-label="正在恢复云作引擎会话">
        <div className="engine-app-heading-skeleton" />
        <div className="engine-app-list-skeleton" />
        <div className="engine-app-list-skeleton is-short" />
      </div>
    );
  }

  if (session.status !== 'authenticated') {
    return (
      <section className="engine-app-access-state">
        <div className="engine-app-access-symbol"><LockKeyhole size={26} /></div>
        <p className="engine-app-eyebrow">受控内测</p>
        <h1>连接你的云作账号</h1>
        <p>使用主站现有登录态完成一次性安全连接。引擎凭证只保存在当前页面内存中。</p>
        {session.error ? <div className="engine-app-inline-error" role="alert">{session.error}</div> : null}
        <button type="button" className="engine-app-primary-button" onClick={() => void session.startSignIn(location.pathname)}>
          继续连接<ArrowRight size={16} />
        </button>
      </section>
    );
  }

  return <>{children}</>;
};

export default SessionGate;

